import isPortalSpecificObjectType from 'customer-data-objects/crmObject/isPortalSpecificObjectType';
import { useCrmLinksContext } from '../../common/context/internal/CrmLinksContext';
import { FetchStatuses, isResolved, isRejected } from '../../common/types/FetchStatus';
export const useObjectTypeSupportsCustomization = (objectTypeId, location) => {
  const allAppSettingsState = useCrmLinksContext();
  if (isPortalSpecificObjectType(objectTypeId)) {
    return {
      status: FetchStatuses.RESOLVED,
      data: true
    };
  }
  if (isResolved(allAppSettingsState)) {
    const appSettings = allAppSettingsState.data.get(objectTypeId);

    // If a Framework App Settings entry does not exist for the given object type
    // or its `enabled` value is false, or location is not present it does not support a record page.
    // If `enabled` is true and location is present, it does.
    const pageEditorSettings = appSettings && appSettings.crmPageEditor && appSettings.crmPageEditor.metadata;
    const pageEditorSettingsEnabled = pageEditorSettings && pageEditorSettings.enabled && pageEditorSettings.enabled.value;
    const pageEditorSettingsLocations = pageEditorSettings && pageEditorSettings.locations && pageEditorSettings.locations.value;
    const canCustomizeObjectType = pageEditorSettingsEnabled && pageEditorSettingsLocations && pageEditorSettingsLocations.includes(location);
    return {
      status: FetchStatuses.RESOLVED,
      data: !!canCustomizeObjectType
    };
  }
  if (isRejected(allAppSettingsState)) {
    return {
      status: FetchStatuses.REJECTED,
      data: null,
      error: allAppSettingsState.error
    };
  }
  return {
    status: allAppSettingsState.status,
    data: null
  };
};